{
  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector("body header-component.header");
    let lastScrollTop = 0;

    function toggleHeaderClass() {
      if (!header) return;

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop <= 50) {
        header.classList.remove("headertop");
        header.classList.remove("headersticky");
      } else {
        header.classList.add("headertop");

        if (scrollTop < lastScrollTop) {
          // scroll up
          header.classList.add("headersticky");
          header.classList.remove("headertop");
        } else {
          // scroll down
          header.classList.remove("headersticky");
        }
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    window.addEventListener("scroll", toggleHeaderClass);
    window.addEventListener("load", toggleHeaderClass);
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("DOMContentLoaded", function () {
      const modal = document.querySelector(".modal__Cus");
      const modalContainer = document.querySelector(".modal__Container");

      if (!modal || !modalContainer) return;

      // Initially hidden
      modal.style.display = "none";

      // 👉 Auto open after 5 seconds
      setTimeout(() => {
        modal.classList.add("active");
        modal.style.display = "flex";
        document.body.classList.add("overflow-hidden"); // optional scroll lock
      }, 5000);

      // 👉 Close on outside click
      modal.addEventListener("click", function (e) {
        if (!modalContainer.contains(e.target)) {
          closeModal();
        }
      });

      // 👉 ESC key close (bonus UX)
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          closeModal();
        }
      });

      function closeModal() {
        modal.classList.remove("active");
        modal.style.display = "none";
        document.body.classList.remove("overflow-hidden");
      }
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".mainVideoBox");
    videoBoxes.forEach((box) => {
      const video = box.querySelector("video");
      const togglePlay = () => {
        if (video.paused) {
          video.controls = true; // Show controls
          video.play();
          box.classList.add("is-playing");
        } else {
          video.pause();
          video.controls = false; // Hide controls
          box.classList.remove("is-playing");
        }
      };
      box.addEventListener("click", togglePlay);
      video.addEventListener("ended", () => {
        box.classList.remove("is-playing");
        video.controls = false; // Hide controls when ended
        video.currentTime = 0;
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("#header-component");
    if (!header) return;
    let ticking = false;
    function updateMenuStyle() {
      const target = window.innerWidth <= 1200 ? "drawer" : "menu";
      const current = header.getAttribute("data-menu-style");
      if (current !== target) {
        header.setAttribute("data-menu-style", target);
      }
      ticking = false;
    }
    updateMenuStyle();
    window.addEventListener("resize", updateMenuStyle, { passive: true });
    const observer = new MutationObserver(() => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateMenuStyle);
      }
    });
    observer.observe(header, {
      attributes: true,
      attributeFilter: ["data-menu-style"],
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    Fancybox.bind("[data-fancybox]", {});
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(".accordion_cus");
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".acco_cus_item");
      if (items.length > 0) {
        items[0].classList.add("open");
      }
      items.forEach((item) => {
        const header = item.querySelector(".acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}





document.addEventListener("DOMContentLoaded", function () {
  const contactLinks = document.querySelectorAll('a[href*="/pages/contact"]');

  contactLinks.forEach(function (link) {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });
});


// (() => {
//   let pending = false;
//   let selfMutation = false;

//   function updateMedia() {
//     const checkedInput = document.querySelector(
//       '.variant-option__button-label input[type="radio"]:checked'
//     );
//     if (!checkedInput) return;
//     const selectedColor = checkedInput.value?.trim().toLowerCase();
//     if (!selectedColor) return; 
//     const productGrid = checkedInput.closest(".product-information__grid");
//     if (!productGrid) return; 
//     const slideshow = productGrid.querySelector("slideshow-component");
//     if (!slideshow) return; 
//     const thumbnails = slideshow.querySelectorAll(".slideshow-controls__thumbnail");
//     const slides = slideshow.querySelectorAll(".product-media-container--image");
//     if (!thumbnails.length && !slides.length) return;
//     let hasMatch = false;
//     for (const slide of slides) {
//       const img = slide.querySelector(".product-media img");
//       if (img && img.alt && img.alt.trim().toLowerCase() === selectedColor) {
//         hasMatch = true;
//         break;
//       }
//     }
//     selfMutation = true;
//     productGrid.classList.toggle("noMatched", !hasMatch);
//     if (!hasMatch) {
//       thumbnails.forEach((thumb) => {
//         thumb.style.display = "";
//         thumb.style.pointerEvents = "";
//         thumb.disabled = false;
//         thumb.removeAttribute("aria-hidden");
//         thumb.removeAttribute("tabindex");
//       });
//       slides.forEach((slide) => {
//         slide.style.display = "";
//         slide.style.pointerEvents = "";
//         slide.removeAttribute("aria-hidden");
//         slide.removeAttribute("tabindex");
//       });
//     } else {
//       thumbnails.forEach((thumb) => {
//         const img = thumb.querySelector("img");
//         if (!img || !img.alt) return;
//         const isMatch = img.alt.trim().toLowerCase() === selectedColor;
//         thumb.style.display = isMatch ? "" : "none";
//         thumb.style.pointerEvents = isMatch ? "" : "none";
//         thumb.disabled = !isMatch;
//         thumb.setAttribute("aria-hidden", String(!isMatch));
//         thumb.tabIndex = isMatch ? 0 : -1;
//       });
//       slides.forEach((slide) => {
//         const img = slide.querySelector(".product-media img");
//         if (!img || !img.alt) return; 
//         const isMatch = img.alt.trim().toLowerCase() === selectedColor;
//         slide.style.display = isMatch ? "" : "none";
//         slide.style.pointerEvents = isMatch ? "" : "none";
//         slide.setAttribute("aria-hidden", String(!isMatch));
//         slide.tabIndex = isMatch ? 0 : -1;
//       });
//     }
//     requestAnimationFrame(() => {
//       selfMutation = false;
//     });
//   }

//   function scheduleUpdate() {
//     if (pending) return;
//     pending = true;
//     requestAnimationFrame(() => {
//       pending = false;
//       updateMedia();
//     });
//   }

//   document.addEventListener("change", (e) => {
//     if (e.target.matches('.variant-option__button-label input[type="radio"]')) {
//       scheduleUpdate();
//     }
//   });

//   const observer = new MutationObserver(() => {
//     if (selfMutation) return;
//     scheduleUpdate();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//   });
//   function tryInitialRun() {
//     const checkedInput = document.querySelector(
//       '.variant-option__button-label input[type="radio"]:checked'
//     );
//     if (checkedInput) {
//       updateMedia();
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", tryInitialRun);
//   } else {
//     tryInitialRun();
//   }
// })();

(() => {
  let pending = false;
  let selfMutation = false;
  function normalize(str) {
    return str.trim().toLowerCase().replace(/\s+/g, " ");
  }
  function altMatchesColor(alt, color) {
    if (!alt || !color) return false;
    const normAlt = normalize(alt);
    const normColor = normalize(color);
    if (!normAlt || !normColor) return false;
    const escaped = normColor.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const re = new RegExp(`(^|[^a-z0-9])${escaped}([^a-z0-9]|$)`, "i");
    return re.test(normAlt);
  }

  function updateMedia() {
    const checkedInput = document.querySelector(
      '.variant-option__button-label input[type="radio"]:checked'
    );
    if (!checkedInput) return;
    const selectedColor = checkedInput.value?.trim().toLowerCase();
    if (!selectedColor) return;
    const productGrid = checkedInput.closest(".product-information__grid");
    if (!productGrid) return;
    const slideshow = productGrid.querySelector("slideshow-component");
    if (!slideshow) return;
    const thumbnails = slideshow.querySelectorAll(".slideshow-controls__thumbnail");
    const slides = slideshow.querySelectorAll(".product-media-container--image");
    if (!thumbnails.length && !slides.length) return;

    let hasMatch = false;
    for (const slide of slides) {
      const img = slide.querySelector(".product-media img");
      if (img && img.alt && altMatchesColor(img.alt, selectedColor)) {
        hasMatch = true;
        break;
      }
    }

    selfMutation = true;
    productGrid.classList.toggle("noMatched", !hasMatch);
    if (!hasMatch) {
      thumbnails.forEach((thumb) => {
        thumb.style.display = "";
        thumb.style.pointerEvents = "";
        thumb.disabled = false;
        thumb.removeAttribute("aria-hidden");
        thumb.removeAttribute("tabindex");
      });
      slides.forEach((slide) => {
        slide.style.display = "";
        slide.style.pointerEvents = "";
        slide.removeAttribute("aria-hidden");
        slide.removeAttribute("tabindex");
      });
    } else {
      thumbnails.forEach((thumb) => {
        const img = thumb.querySelector("img");
        if (!img || !img.alt) return;
        const isMatch = altMatchesColor(img.alt, selectedColor);
        thumb.style.display = isMatch ? "" : "none";
        thumb.style.pointerEvents = isMatch ? "" : "none";
        thumb.disabled = !isMatch;
        thumb.setAttribute("aria-hidden", String(!isMatch));
        thumb.tabIndex = isMatch ? 0 : -1;
      });
      slides.forEach((slide) => {
        const img = slide.querySelector(".product-media img");
        if (!img || !img.alt) return;
        const isMatch = altMatchesColor(img.alt, selectedColor);
        slide.style.display = isMatch ? "" : "none";
        slide.style.pointerEvents = isMatch ? "" : "none";
        slide.setAttribute("aria-hidden", String(!isMatch));
        slide.tabIndex = isMatch ? 0 : -1;
      });
    }
    requestAnimationFrame(() => {
      selfMutation = false;
    });
  }

  function scheduleUpdate() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      updateMedia();
    });
  }

  document.addEventListener("change", (e) => {
    if (e.target.matches('.variant-option__button-label input[type="radio"]')) {
      scheduleUpdate();
    }
  });

  const observer = new MutationObserver(() => {
    if (selfMutation) return;
    scheduleUpdate();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  function tryInitialRun() {
    const checkedInput = document.querySelector(
      '.variant-option__button-label input[type="radio"]:checked'
    );
    if (checkedInput) {
      updateMedia();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInitialRun);
  } else {
    tryInitialRun();
  }
})();